// Бесконечный слайдер для видео превью с ручной прокруткой
(function() {
  function init() {
  try {
  const videosContainer = document.querySelector('.background-block_videos');
  if (!videosContainer) return;

  const videos = Array.from(videosContainer.querySelectorAll('.background-block_video'));
  if (videos.length === 0) return;

  const totalVideos = videos.length;
  let currentIndex = 0;
  let isAnimating = false;
  let scrollTimeout = null;
  
  // Функция для остановки всех видео
  function stopAllVideos() {
    videos.forEach(video => {
      const videoElement = video.querySelector('video');
      if (videoElement) {
        videoElement.pause();
        videoElement.currentTime = 0;
        videoElement.muted = true;
      }
      video.classList.remove('playing', 'active');
    });
  }
  
  // Функция для воспроизведения активного видео
  function playActiveVideo() {
    const activeVideo = videos[currentIndex];
    if (activeVideo) {
      const videoElement = activeVideo.querySelector('video');
      if (videoElement) {
        // Видео остается заглушенным до клика на кнопку play
        videoElement.muted = true;
      }
      activeVideo.classList.add('active');
    }
  }

  function updateSlider() {
    if (isAnimating) return;
    isAnimating = true;
    
    // Останавливаем все видео перед сменой слайда
    stopAllVideos();

    videos.forEach((video, index) => {
      // Определяем позицию относительно текущего индекса
      const realIndex = index % totalVideos;
      const relativePosition = (realIndex - currentIndex + totalVideos) % totalVideos;
      
      // Центральная картинка (текущая) - спереди
      if (relativePosition === 0) {
        video.style.transform = 'translateX(0) scale(1)';
        video.style.filter = 'none';
        video.style.opacity = '1';
        video.style.zIndex = '5';
      }
      // Левая картинка (следующая) - сзади слева, больше выглядывает
      else if (relativePosition === 1) {
        video.style.transform = 'translateX(-110px) scale(0.95)';
        video.style.filter = 'grayscale(100%)';
        video.style.opacity = '0.9';
        video.style.zIndex = '2';
      }
      // Правая картинка (предыдущая) - сзади справа, больше выглядывает
      else if (relativePosition === totalVideos - 1) {
        video.style.transform = 'translateX(120px) scale(0.95)';
        video.style.filter = 'grayscale(100%)';
        video.style.opacity = '0.9';
        video.style.zIndex = '2';
      }
      // Дальние картинки - еще дальше и прозрачнее
      else {
        const isLeft = relativePosition <= totalVideos / 2;
        const distance = isLeft ? relativePosition : totalVideos - relativePosition;
        const screenWidth = window.innerWidth;
        
        // При 393px и меньше смещаем дальние элементы ближе к центру, чтобы они не были видны
        let translateX;
        if (screenWidth <= 393) {
          translateX = isLeft ? -20 - (distance - 1) * 15 : 20 + (distance - 1) * 15;
        } else {
          translateX = isLeft ? -50 - (distance - 1) * 30 : 50 + (distance - 1) * 30;
        }
        
        const scale = 1 - distance * 0.15;
        const opacity = Math.max(0.2, 0.7 - (distance - 1) * 0.15);
        
        video.style.transform = `translateX(${translateX}px) scale(${scale})`;
        video.style.filter = 'grayscale(100%)';
        video.style.opacity = opacity.toString();
        video.style.zIndex = '1';
      }
    });

    setTimeout(() => {
      isAnimating = false;
      // Устанавливаем активное видео после завершения анимации
      playActiveVideo();
    }, 600);
  }

  function nextSlide() {
    if (isAnimating) return;
    currentIndex = (currentIndex + 1) % totalVideos;
    updateSlider();
  }

  function prevSlide() {
    if (isAnimating) return;
    currentIndex = (currentIndex - 1 + totalVideos) % totalVideos;
    updateSlider();
  }

  // Инициализация
  updateSlider();
  
  // Обработчики для кнопок play
  videos.forEach((videoContainer, index) => {
    const playButton = videoContainer.querySelector('.video-play-button');
    const videoElement = videoContainer.querySelector('video');
    
    if (playButton && videoElement) {
      playButton.addEventListener('click', (e) => {
        e.stopPropagation();
        
        // Проверяем, является ли это видео активным
        if (!videoContainer.classList.contains('active')) return;
        
        if (videoElement.paused) {
          // Включаем звук и запускаем видео
          videoElement.muted = false;
          videoElement.play();
          videoContainer.classList.add('playing');
        } else {
          // Ставим на паузу
          videoElement.pause();
          videoContainer.classList.remove('playing');
        }
      });
      
      // Показываем кнопку play когда видео закончилось
      videoElement.addEventListener('ended', () => {
        videoContainer.classList.remove('playing');
        videoElement.currentTime = 0;
      });
      
      // Клик по самому видео тоже работает как play/pause
      videoElement.addEventListener('click', (e) => {
        e.stopPropagation();
        if (!videoContainer.classList.contains('active')) return;
        
        if (videoElement.paused) {
          videoElement.muted = false;
          videoElement.play();
          videoContainer.classList.add('playing');
        } else {
          videoElement.pause();
          videoContainer.classList.remove('playing');
        }
      });
    }
  });

  // Обновляем позиции при изменении размера окна
  window.addEventListener('resize', () => {
    updateSlider();
  });

  // Обработка прокрутки колесиком мыши и перетаскивания
  const wrapper = document.querySelector('.background-block_videos-wrapper');
  if (wrapper) {
    let wheelDelta = 0;
    let isDragging = false;
    let startX = 0;
    let currentX = 0;
    let dragThreshold = 50; // Минимальное расстояние для смены слайда
    
    // Прокрутка колесиком мыши (десктоп)
    wrapper.addEventListener('wheel', (e) => {
      e.preventDefault();
      
      wheelDelta += e.deltaY;
      
      // Очищаем предыдущий таймаут
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
      
      // Если накопилось достаточно прокрутки, меняем слайд
      if (Math.abs(wheelDelta) > 50) {
        if (wheelDelta > 0) {
          nextSlide();
        } else {
          prevSlide();
        }
        wheelDelta = 0;
      }
      
      // Сбрасываем накопленную прокрутку через небольшую задержку
      scrollTimeout = setTimeout(() => {
        wheelDelta = 0;
      }, 100);
    }, { passive: false });
    
    // Перетаскивание мышью (десктоп)
    wrapper.addEventListener('mousedown', (e) => {
      isDragging = true;
      startX = e.clientX;
      currentX = startX;
      wrapper.style.cursor = 'grabbing';
      e.preventDefault();
    });
    
    document.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      currentX = e.clientX;
    });
    
    document.addEventListener('mouseup', () => {
      if (!isDragging) return;
      
      const diff = startX - currentX;
      
      if (Math.abs(diff) > dragThreshold) {
        if (diff > 0) {
          // Перетащили влево - предыдущий слайд (исправлено направление)
          prevSlide();
        } else {
          // Перетащили вправо - следующий слайд (исправлено направление)
          nextSlide();
        }
      }
      
      isDragging = false;
      wrapper.style.cursor = 'grab';
    });
    
    // Устанавливаем курсор при наведении
    wrapper.style.cursor = 'grab';
  }
  
  // Обработка свайпов на мобильных устройствах
  let touchStartX = 0;
  let touchStartY = 0;
  let touchEndX = 0;
  
  if (wrapper) {
    wrapper.addEventListener('touchstart', (e) => {
      const touch = e.touches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
    }, { passive: true });
  
    wrapper.addEventListener('touchmove', (e) => {
      const touch = e.touches[0];
      const touchCurrentX = touch.clientX - touchStartX;
      const touchCurrentY = touch.clientY - touchStartY;
      
      // Если жест преимущественно горизонтальный — блокируем вертикальный скролл страницы
      if (Math.abs(touchCurrentX) > Math.abs(touchCurrentY) && Math.abs(touchCurrentX) > 5) {
        e.preventDefault();
      }
    }, { passive: false });
  
    wrapper.addEventListener('touchend', (e) => {
      const touch = e.changedTouches[0];
      touchEndX = touch.clientX;
      handleSwipe();
    }, { passive: true });
  }
  
  function handleSwipe() {
    const swipeThreshold = 50;
    const diff = touchStartX - touchEndX;
  
    if (Math.abs(diff) > swipeThreshold && !isAnimating) {
      if (diff > 0) {
        // Свайп влево - предыдущий слайд (исправлено направление)
        prevSlide();
      } else {
        // Свайп вправо - следующий слайд (исправлено направление)
        nextSlide();
      }
    }
  }
  
  // Обработчики для кнопок навигации
  const prevButton = document.querySelector('.video-slider-btn-prev');
  const nextButton = document.querySelector('.video-slider-btn-next');
  
  if (prevButton) {
    prevButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (!isAnimating) {
        prevSlide();
      }
    });
  }
  
  if (nextButton) {
    nextButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (!isAnimating) {
        nextSlide();
      }
    });
  }
  
  } catch (e) {
  }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

